
import Logging from '@/logging';
import gql from 'graphql-tag';
import Vue from 'vue';
import { mapGetters } from 'vuex';

const UPDATE_NOTE = gql`
mutation ComponentsTimelineNote_updateNote ($reference: uuid!, $note: String!) {
  update_risolto_note(
    where: {reference: {_eq: $reference}}
    _set: {note: $note}
  ) {
    updated_count: affected_rows
    updated: returning {
      reference
      note
    }
  }
}
`;

export default Vue.extend({
	props: {
		item: { type: Object, required: true }
	},
	data() {
		return {
			expanded: false,
			editMode: false,
			originalNote: ''
		};
	},
	computed: {
		...mapGetters(['loggedInUser'])
	},
	mounted() {
		this.originalNote = this.item.metadata.note;
	},
	methods: {
		handleShowLess() {
			this.expanded = false;
		},
		handleShowAll() {
			this.expanded = true;
		},
		handleInvoiceClick(val) {
			Logging.log('val', val);
			this.$router.push({ name: 'invoice-detail', params: { reference: val, participant: this.$store.getters.selectedParticipantStore } });
		},
		handleEditNote() {
			this.editMode = true;
		},
		handleSaveNote() {
			if (!this.editMode) {
				return;
			}

			// Graphql mutation
			this.$apollo
				.mutate({
					mutation: UPDATE_NOTE,
					variables: {
						reference: this.item.note,
						note: this.item.metadata.note
					}
				})
				.then(({ data }) => {
					this.editMode = false;
					this.originalNote = this.item.metadata.note;
					this.$notify({
						title: this.$t('success'),
						message: this.$t('saved'),
						type: 'success'
					});
				})
				.catch((error) => {
					Logging.error(error);
					this.$notify({
						title: this.$t('somethingWentWrong'),
						message: this.$t('somethingWentWrong'),
						type: 'error'
					});
				});
		},
		handleCancelEditNote() {
			if (!this.editMode) {
				return;
			}
			this.editMode = false;
			this.item.metadata.note = this.originalNote;
		}
	}
});
